/**
 * @generated SignedSource<<7038f155bdf5e795c18a796ea190b2dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AssigneesSectionCopilotRepositoryFragment$data = {
  readonly databaseId: number | null | undefined;
  readonly isArchived: boolean;
  readonly nameWithOwner: string;
  readonly " $fragmentType": "AssigneesSectionCopilotRepositoryFragment";
};
export type AssigneesSectionCopilotRepositoryFragment$key = {
  readonly " $data"?: AssigneesSectionCopilotRepositoryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AssigneesSectionCopilotRepositoryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AssigneesSectionCopilotRepositoryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameWithOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArchived",
      "storageKey": null
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "4544821435ac12a317ffb25bd81a5c62";

export default node;
